import { GridCellParams } from '@mui/x-data-grid'

import { Text } from '@mxenabled/mxui'

const AccountCell = (params: GridCellParams) => (
  <Text tabIndex={params.tabIndex} variant="body2">
    {`${params.row.account}`}
    {params.row.number && ` | ${params.row.number}`}
  </Text>
)

export default AccountCell
